import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, errorInfo);
    }
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      fallbackRender
    } = this.props;
    if (hasError) {
      if (typeof fallbackRender === 'function') {
        return fallbackRender();
      } else {
        // Use empty div as fallback if no other fallback is set
        return /*#__PURE__*/React.createElement("div", null);
      }
    }
    return children;
  }
}

export { ErrorBoundary as default };
